import React from 'react';

export default function EmptyState({ title = 'No content yet', message = 'Content will appear here once available.', icon }) {
  return (
    <div className="mol-empty-state">
      <div className="mol-empty-state__icon">
        {icon || (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
            <polyline points="13 2 13 9 20 9" />
          </svg>
        )}
      </div>
      <h3 className="mol-empty-state__title">{title}</h3>
      <p className="mol-empty-state__message">{message}</p>
    </div>
  );
}
